<app-header
  canvasMode="settings"
  [loggedIn]="true"
  canvasType="settings"
  [fixedHeader]="true"
></app-header>

<div class="home-container">
  <h1 class="welcome-message">Settings</h1>

  <div class="description">
    <span>Disclaimer: DO NOT MODIFY ANYTHING ON THESE PAGES. </span>Publishing
    has the potential to impact all customers. If you have questions regarding
    any information on this page, please contact the Product team. <BR /> <BR />
    Chislic t-bone landjaeger, ground round cupim chuck pork chop sausage
    hamburger tail kevin meatloaf turkey buffalo bacon. Flank turkey shoulder,
    sausage ground round strip steak prosciutto. Swine jowl sausage meatball
    biltong. Turducken chislic burgdoggen kevin meatball buffalo.
    <BR /> <BR />
    Pork chop pork belly chislic sausage. Prosciutto turducken landjaeger, shank
    flank short ribs boudin bresaola salami ham hock short loin chuck strip
    steak frankfurter shoulder. Beef ribs burgdoggen salami, porchetta ball tip
    pig cow ham hock sirloin jowl chicken. Tail venison beef ribs swine.
    <BR /> <BR />
    Chuck jerky chislic meatball capicola. Strip steak chuck alcatra short loin
    t-bone pancetta shankle cupim short ribs. Hamburger filet mignon biltong
    flank pancetta tri-tip t-bone alcatra ribeye. Meatloaf swine capicola salami
    rump pork doner bacon tail chuck prosciutto hamburger. Shankle flank pig
    drumstick fatback turkey.
  </div>
  <BR /><BR />
  <section *ngIf="enablePublishing">
    <div class="heading">Publishing</div>
    <div class="details">
      Prosciutto fatback sausage buffalo, corned beef ham hock rump short loin
      short ribs bacon. Sirloin picanha shoulder cow, capicola pork chop cupim
      tenderloin tri-tip swine frankfurter fatback shankle jowl filet mignon.
      Beef ribs capicola jowl tail.
    </div>
    <a routerLink="/settings/publish" title="Publishing">Canvas Publishing</a>
  </section>
  <BR /><BR />
  <section *ngIf="enableCMS">
    <div class="heading">Content</div>
    <div class="details">
      Prosciutto fatback sausage buffalo, corned beef ham hock rump short loin
      short ribs bacon. Sirloin picanha shoulder cow, capicola pork chop cupim
      tenderloin tri-tip swine frankfurter fatback shankle jowl filet mignon.
      Beef ribs capicola jowl tail.
    </div>

    <a routerLink="/settings/cms" title="CMS">CMS Dashboard</a>
  </section>
</div>
